// src/App.jsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import axios from 'axios';
import thTH from 'antd/locale/th_TH'; // ถ้าคุณใช้ภาษาไทย
import { useMediaQuery } from 'react-responsive';

import Login from './pages/Auth/LoginPage';
import Dashboard from './pages/Dashboard/index';
import InfographicPage from './pages/Dashboard/InfographicPage';
import TempleManagement from './pages/temples/TempleManagement';
import TempleOrderPage from './pages/temples/TempleOrderPage';
import MainLayout from './layouts/MainLayout';

import ProtectedRoutes from './routes/ProtectedRoute';
import { Provider } from 'react-redux';
import store from './store/'; // ← ต้องชี้ไปที่ store ของคุณ
import TempleDetail from './pages/temples/TempleDetail';
import MonksPage from './pages/Monks';
import MonkDetailPage from './pages/Monks/MonkDetailPage';
import UserManagement from './pages/users/UserManagement';
import MyProfile from './pages/users/MyProfile';
import NewsList from './pages/News/NewsList';
import NewsForm from './pages/News/NewsForm';
import MapsScreen from './pages/temples/MapPage';
import PrintPreview from './pages/temples/PrintPreview';
import NextCloudSettings from './pages/Settings/NextCloudSettings';
import GoogleDriveSettings from './pages/Settings/GoogleDriveSettings';
import SiteSettings from './pages/Settings/SiteSettings';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import { PermissionProvider } from './context/PermissionContext';
import RoleManagement from './pages/users/RoleManagement';
import AuditLogPage from './pages/audit/AuditLogPage';

//public screen
import PublicLayout from './pages/Public/Template/PublicLayout'; //template layout
import LandingPage from './pages/Public/LandingPage';
import NewsPage from './pages/Public/News';
import NewsDetailPage from './pages/Public/News/NewsDetailPage';

// แนบ Bearer token ให้ทุกคำขอ axios อัตโนมัติ (หน้า protected ทั้งหมด เช่น TempleDetail/PrintPreview/MonkForm/ImportModal)
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  return config;
});


const App = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const Layout = MainLayout;
  const [isLogIn, setIsLogin] = useState(false);
  const navigate = useNavigate();


  return (
    <ConfigProvider
      locale={thTH}
      theme={{
        token: {
          fontFamily: 'Kanit, sans-serif',
          fontSize: 17, // 🔸 ค่า default (px) สำหรับทุก component
        },
      }}
    >
      <Provider store={store}>
        <SiteSettingsProvider>
          <PermissionProvider>
          <Routes>

          <Route element={<PublicLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:id" element={<NewsDetailPage />} />


          </Route>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard/infographic" element={<InfographicPage />} />
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/temples" element={<TempleManagement />} />
              <Route path="/temples/order" element={<TempleOrderPage />} />
              {/* ...route อื่น ๆ */}
              <Route path="/maps" element={<MapsScreen />} />
              <Route path="/temples/:id" element={<TempleDetail />} />
              <Route path="/monks" element={<MonksPage />} />
              <Route path="/monks/:id" element={<MonkDetailPage />} />
              <Route path="/users" element={<UserManagement />} />
              <Route path="/me" element={<MyProfile />} />
              <Route path="/news-managments" element={<NewsList />} />
              <Route path="/news-detail" element={<NewsForm />} />
              <Route path="/news-detail/:id" element={<NewsForm />} />
              <Route path="/print-preview/:id" element={<PrintPreview />} />
              <Route path="/settings/nextcloud" element={<NextCloudSettings />} />
              <Route path="/settings/googledrive" element={<GoogleDriveSettings />} />
              <Route path="/settings/site" element={<SiteSettings />} />
              <Route path="/roles" element={<RoleManagement />} />
              <Route path="/audit-logs" element={<AuditLogPage />} />

            </Route>
          </Route>

          <Route path="*" element={<div>404 - ไม่พบหน้า</div>} />
        </Routes>
        </PermissionProvider>
        </SiteSettingsProvider>
      </Provider>
    </ConfigProvider>
  );
};

export default App;
